import { DEFAULT_MARKET, MarketCodesEnum, MarketType, marketsList } from 'constants/markets';
import MarketHelper from 'helpers/MarketHelper';

const swedishLanguagePrefixRegex = /^\/sv\/?.*$/;

export function getReferrerMarket(forwardedFor?: string | string[] | null): MarketType {
    const referrer = Array.isArray(forwardedFor) ? forwardedFor[0] : forwardedFor;

    const referrerWithProtocol = /^https?:\/\//i.test(referrer ?? '') ? referrer : `http://${referrer}`;

    let url;

    try {
        url = new URL(referrerWithProtocol?.toLowerCase() ?? '');
    } catch (error) {
        return DEFAULT_MARKET;
    }

    const domainParts = url.hostname?.split('.');

    const matchedMarketCode = parseMarketCode(domainParts, url.pathname);

    if (matchedMarketCode && MarketHelper.isValidMarket(matchedMarketCode)) {
        return matchedMarketCode;
    }

    return DEFAULT_MARKET;
}

function parseMarketCode(domainParts: string[], path: string): string {
    const matchedMarketCode = domainParts
        .filter((part) => marketsList
            .some((market) => market === part))?.[0];

    if (matchedMarketCode === MarketCodesEnum.Finland && swedishLanguagePrefixRegex.test(path)) {
        return MarketCodesEnum.FinlandSwedish;
    }

    if (matchedMarketCode === MarketCodesEnum.Finland && path.includes('/sefi/')) {
        return MarketCodesEnum.FinlandSwedish;
    }

    return matchedMarketCode;
}
